import { IApplicationState } from '../../types/redux';

export function getDiscounts(state: IApplicationState) {
  return state.developer.discounts;
}
